import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDBox";

import GridContainer from "components/Grid/GridContainer.js";


import OverallReports from "./components/OverallReports.js";
import SalesGraph from "./components/SalesGraph.js";
import StoreReportProducts from "./components/StoreReportProducts.js";
import StoreReportVendors from "./components/StoreReportVendors.js";

import EarningReports from "./components/EarningReports.js";

import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";

import axios from "axios";
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { checkPrivilege, handleErrors } from "../../common.js";
import { PRIVILEGE } from "../../constants.js";
import Config from "../../config.js";
import { useEffect, useState, useContext } from "react";

import '../../assets/style/style.css';
import CircularProgress from '@mui/material/CircularProgress';

function Dashboard() {

  const adminType = localStorage.getItem("type");
  const navigate   = useNavigate();
  const { t }     = useTranslation();
  const BASE  = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [isLoading, setIsLoading] = useState(false);
  const [isProductsLoading, setIsProductsLoading] = useState(false);
  const [isVendorsLoading, setIsVendorsLoading] = useState(false);
  const [isEarningsLoading, setIsEarningsLoading] = useState(false);
  const [backendResponseStatus, setBackendResponseStatus] = useState(0);
  const [productsObjectToday, setProductsObjectToday] = useState({});
  const [productsObjectWeek, setProductsObjectWeek] = useState({});
  const [productsObjectMonth, setProductsObjectMonth] = useState({});
  const [productsObjectYear, setProductsObjectYear] = useState({});
  const [productsObjectAllTime, setProductsObjectAllTime] = useState({});

  const [vendorsObjectToday, setVendorsObjectToday] = useState({});
  const [vendorsObjectWeek, setVendorsObjectWeek] = useState({});
  const [vendorsObjectMonth, setVendorsObjectMonth] = useState({});
  const [vendorsObjectYear, setVendorsObjectYear] = useState({});
  const [vendorsObjectAllTime, setVendorsObjectAllTime] = useState({});

  const [earningsObjectToday, setEarningsObjectToday] = useState({});
  const [earningsObjectWeek, setEarningsObjectWeek] = useState({});
  const [earningsObjectMonth, setEarningsObjectMonth] = useState({});
  const [earningsObjectYear, setEarningsObjectYear] = useState({});
  const [earningsObjectAllTime, setEarningsObjectAllTime] = useState({});  
  const [graphData, setGraphData] = useState({});
  const [overallReportObject, setOverallReportObject] = useState({});

  useEffect(() => {
    loadDashboardContents("today", "all-section");
  }, []);

  const handleTimeperiodClick = (timePeriod, dashboardSection) => {

    loadDashboardContents(timePeriod, dashboardSection);

  };


  const loadDashboardContents = (timePeriod, dashboardSection) => {

    if(dashboardSection === "products")
    {
        if(timePeriod === "today" && Object.keys(productsObjectToday).length > 0)
        return;

        if(timePeriod === "week" && Object.keys(productsObjectWeek).length > 0)
        return;

        if(timePeriod === "month" && Object.keys(productsObjectMonth).length > 0)
        return;

        if(timePeriod === "year" && Object.keys(productsObjectYear).length > 0)
        return;

        if(timePeriod === "all-time" && Object.keys(productsObjectAllTime).length > 0)
        return;
    }
    
    if(dashboardSection === "vendors")
    {
        if(timePeriod === "today" && Object.keys(vendorsObjectToday).length > 0)
        return;

        if(timePeriod === "week" && Object.keys(vendorsObjectWeek).length > 0)
        return;

        if(timePeriod === "month" && Object.keys(vendorsObjectMonth).length > 0)
        return;

        if(timePeriod === "year" && Object.keys(vendorsObjectYear).length > 0)
        return;

        if(timePeriod === "all-time" && Object.keys(vendorsObjectAllTime).length > 0)
        return;
    }

    if(dashboardSection === "earnings")
    {
        if(timePeriod === "today" && Object.keys(earningsObjectToday).length > 0)
        return;

        if(timePeriod === "week" && Object.keys(earningsObjectWeek).length > 0)
        return;

        if(timePeriod === "month" && Object.keys(earningsObjectMonth).length > 0)
        return;

        if(timePeriod === "year" && Object.keys(earningsObjectYear).length > 0)
        return;

        if(timePeriod === "all-time" && Object.keys(earningsObjectAllTime).length > 0)
        return;
    }

    if(dashboardSection === "all-section")
    setIsLoading(true);

    if(dashboardSection === "products")
    setIsProductsLoading(true);

    if(dashboardSection === "vendors")
    setIsVendorsLoading(true);

    if(dashboardSection === "earnings")
    setIsEarningsLoading(true);

    axios({      
          url     : BASE+"api/dashboard/dashboard-widgets/"+timePeriod+"/"+dashboardSection,
          method  : "GET",
          headers : {
            Authorization   : `Bearer ${TOKEN}`,
            function        : Config.FUNCTION_KEY
          },        
        }).then(function (response) 
        {
            if(dashboardSection === "all-section")
            setIsLoading(false);

            if(dashboardSection === "products")
            setIsProductsLoading(false);
        
            if(dashboardSection === "vendors")
            setIsVendorsLoading(false);
        
            if(dashboardSection === "earnings")
            setIsEarningsLoading(false);            

            const responseData           = response.data;
            const responseStatusCode     = response.status;

            if(responseStatusCode === 200)
            {               
                if(responseData && responseData.data)
                { 
                  setBackendResponseStatus(responseData.status);
                  
                  if(
                    responseData.data && 
                    responseData.data.overallReportObject
                  )
                  setOverallReportObject(responseData.data.overallReportObject);

                  if(
                    responseData.data && 
                    responseData.data.graphObject && 
                    responseData.data.graphObject.graphData
                  )
                  setGraphData(responseData.data.graphObject.graphData);   

                  if(
                    responseData.data && 
                    responseData.data.productsObject
                  )
                  {
                    if(timePeriod === "today")
                    setProductsObjectToday(responseData.data.productsObject);
            
                    if(timePeriod === "week")
                    setProductsObjectWeek(responseData.data.productsObject);
            
                    if(timePeriod === "month")
                    setProductsObjectMonth(responseData.data.productsObject);
            
                    if(timePeriod === "year")
                    setProductsObjectYear(responseData.data.productsObject);
            
                    if(timePeriod === "all-time")
                    setProductsObjectAllTime(responseData.data.productsObject);                   
                  }                  

                  if(
                    responseData.data && 
                    responseData.data.vendorsObject
                  )
                  {
                    if(timePeriod === "today")
                    setVendorsObjectToday(responseData.data.vendorsObject);
            
                    if(timePeriod === "week")
                    setVendorsObjectWeek(responseData.data.vendorsObject);
            
                    if(timePeriod === "month")
                    setVendorsObjectMonth(responseData.data.vendorsObject);
            
                    if(timePeriod === "year")
                    setVendorsObjectYear(responseData.data.vendorsObject);
            
                    if(timePeriod === "all-time")
                    setVendorsObjectAllTime(responseData.data.vendorsObject);    
                  }

                  if(
                    responseData.data && 
                    responseData.data.earningsObject
                  )
                  {
                    if(timePeriod === "today")
                    setEarningsObjectToday(responseData.data.earningsObject);
            
                    if(timePeriod === "week")
                    setEarningsObjectWeek(responseData.data.earningsObject);
            
                    if(timePeriod === "month")
                    setEarningsObjectMonth(responseData.data.earningsObject);
            
                    if(timePeriod === "year")
                    setEarningsObjectYear(responseData.data.earningsObject);
            
                    if(timePeriod === "all-time")
                    setEarningsObjectAllTime(responseData.data.earningsObject);    
                  }             
                }
            }  
            else 
            {
              toast.error(t('An unexpected error occurred while communicating with server'));
              return;            
            }        
        }).catch(function (error) {

          if(dashboardSection === "all-section")
          setIsLoading(false);
          
          handleErrors(error, t, navigate);
        });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        
        {isLoading ?       
              <MDBox py={3} sx={{ textAlign: "center" }}>   
                <CircularProgress size={30} style={{color: '#1a90ff', margin: '0px auto'}}/>
              </MDBox>
        : <></>}

        {backendResponseStatus === 1 && Object.keys(overallReportObject).length === 0 ?
        <MDTypography fontWeight="small">{t("You do not have enough privilege to access this page")}</MDTypography>
        : <></>}
        
        {Object.keys(overallReportObject).length > 0 ?
          <OverallReports overallReportObject = {overallReportObject} />       
        : <></>}

        {Object.keys(graphData).length > 0 ?
          <SalesGraph graphData = {graphData} />       
        : <></>}

        <GridContainer>

          <StoreReportVendors 
              isVendorsLoading     = {isVendorsLoading}
              vendorsObjectToday   = {vendorsObjectToday} 
              vendorsObjectWeek    = {vendorsObjectWeek} 
              vendorsObjectMonth   = {vendorsObjectMonth} 
              vendorsObjectYear    = {vendorsObjectYear} 
              vendorsObjectAllTime = {vendorsObjectAllTime} 
              tabOnClick           = {handleTimeperiodClick}
          /> 

          <StoreReportProducts 
              isProductsLoading     = {isProductsLoading}
              productsObjectToday   = {productsObjectToday} 
              productsObjectWeek    = {productsObjectWeek} 
              productsObjectMonth   = {productsObjectMonth} 
              productsObjectYear    = {productsObjectYear} 
              productsObjectAllTime = {productsObjectAllTime} 
              tabOnClick            = {handleTimeperiodClick}
          /> 
          
          <EarningReports 
              isEarningsLoading     = {isEarningsLoading}
              earningsObjectToday   = {earningsObjectToday} 
              earningsObjectWeek    = {earningsObjectWeek} 
              earningsObjectMonth   = {earningsObjectMonth} 
              earningsObjectYear    = {earningsObjectYear} 
              earningsObjectAllTime = {earningsObjectAllTime} 
              tabOnClick            = {handleTimeperiodClick}
          /> 
             
            
        </GridContainer>
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
